module.exports = __webpack_public_path__ + "static/media/3_avatar.0c83eae3.png";